import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { logout } from "../services/auth";
import "../style.css";

export default function Layout({ children }) {
  const nav = useNavigate();

  function doLogout() {
    logout();
    nav("/login");
  }

  return (
    <div className="container">
      <div className="main-card">
        <div className="topbar">
          <div className="brand">
            <span className="brand-dot" />
            <span>RK Solar Admin Panel</span>

          </div>
          <button className="btn btn-ghost" onClick={doLogout}>Logout</button>
        </div>

        <div className="grid grid-2">
          <aside className="sidebar">
            <div className="grid" style={{ gap: 8 }}>
              <NavLink className={({ isActive }) => `navItem ${isActive ? "active" : ""}`} to="/dashboard">
                Dashboard
              </NavLink>
              <NavLink className={({ isActive }) => `navItem ${isActive ? "active" : ""}`} to="/blogs">
                Blogs
              </NavLink>
              <NavLink className={({ isActive }) => `navItem ${isActive ? "active" : ""}`} to="/categories">
                Categories
              </NavLink>

              <NavLink to="/contacts" className={({ isActive }) => "navItem" + (isActive ? " active" : "")}>
                Contacts
              </NavLink>

              <NavLink to="/landing-leads" className={({ isActive }) =>
                "navItem" + (isActive ? " active" : "")
              }>
                Landing Leads
              </NavLink>


            </div>

            <hr className="sep" />

          </aside>

          <main style={{ padding: 16 }}>{children}</main>
        </div>
      </div>
    </div>
  );
}
